import { Article, DocsHeader, DocsIntro, Section, SectionHeader, Image, DocsHeading } from "../extra/Components";

import landning from '../assets/7 landning/1-2 landning2-small.jpg';
import landning_small from '../assets/7 landning/1-2 landning2-small.jpg';
import riktning from '../assets/7 landning/3 riktning-small.jpg';
import riktning_small from '../assets/7 landning/3 riktning-small.jpg';
import landningsvarv from '../assets/7 landning/landningsvarv 0vind-small.png';
import landningsvarv_small from '../assets/7 landning/landningsvarv 0vind-small.png';
import landningsvarv2 from '../assets/7 landning/landningsvarv 6vind-small.png';
import landningsvarv2_small from '../assets/7 landning/landningsvarv 6vind-small.png';
import flar from '../assets/7 landning/5 flär2-small.jpg';
import flar_small from '../assets/7 landning/5 flär2-small.jpg';
import rullning from '../assets/7 landning/5 inte rullning2-small.jpg';
import rullning_small from '../assets/7 landning/5 inte rullning2-small.jpg';
import utelandning from '../assets/7 landning/6 utelandning-small.jpg';
import utelandning_small from '../assets/7 landning/6 utelandning-small.jpg';
import valAvPlats from '../assets/7 landning/7 valAvPlats-ritad-small.jpg';
import valAvPlats_small from '../assets/7 landning/7 valAvPlats-ritad-small.jpg';
import taklandning from '../assets/7 landning/kassaPlatser/1 taklandning-small.jpg';
import taklandning_small from '../assets/7 landning/kassaPlatser/1 taklandning-small.jpg';
import vattenlandning from '../assets/7 landning/kassaPlatser/2 vattenlandning-small.jpg';
import vattenlandning_small from '../assets/7 landning/kassaPlatser/2 vattenlandning-small.jpg';
import trad from '../assets/7 landning/kassaPlatser/3 DSCF3312-small.jpg';
import trad_small from '../assets/7 landning/kassaPlatser/3 DSCF3312-small.jpg';
import akerlandning from '../assets/7 landning/kassaPlatser/4 åkerlandning-small.jpg';
import akerlandning_small from '../assets/7 landning/kassaPlatser/4 åkerlandning-small.jpg';
import banan from '../assets/7 landning/kassaPlatser/5 banan-small.jpg';
import banan_small from '../assets/7 landning/kassaPlatser/5 banan-small.jpg';
import kraftledning from '../assets/7 landning/kassaPlatser/11 kraftledning-small.jpg';
import kraftledning_small from '../assets/7 landning/kassaPlatser/11 kraftledning-small.jpg';
import vag from '../assets/7 landning/kassaPlatser/12 väg-small.jpg';
import vag_small from '../assets/7 landning/kassaPlatser/12 väg-small.jpg';
import hage from '../assets/7 landning/kassaPlatser/13 hage-small.jpg';
import hage_small from '../assets/7 landning/kassaPlatser/13 hage-small.jpg';
import bargning from '../assets/7 landning/8 bärgningcropped-small.jpg';
import bargning_small from '../assets/7 landning/8 bärgningcropped-small.jpg';
import { Question, Questionary } from "../extra/Quiz";

import {
    faPlaneArrival,
} from "@fortawesome/free-solid-svg-icons";

const landningQuiz = [
    Question.order("Landningens prioriteringar", ["Fallskärmen parallellt med marken", "Lämplig landningsplats", "Landningsställning", "Bromsa aldrig mindre efter du börjat flära", "Mot vinden"]),
    Question.oneQ("På vilken höjd påbörjar man sin final?", "100m", ["200m", "300m", "400m"]),
    Question.oneQ("På vilken höjd påbörjar man sin bas?", "200m", ["100m", "300m", "400m"]),
    Question.oneQ("På vilken höjd påbörjar man sin medvind?", "300m", ["100m", "200m", "400m"]),
    Question.qManyA("Vad kan användas för att bestämma vindriktning", ["Vind T", "Vindstruten", "Flaggor"], ["T som ligger på marken", "Fartvinden", "Flygplanets landningsriktning"]),
    Question.oneQ("Jag kommer bedömas på min landningsprecision under utbildningen?", "Nej, säkra landningar framför allt", ["Ja"]),
    Question.qManyA("Om det blåser mycket kommer", ["Min final vara kortare än min medvind", "Min final vara kortare än vid nollvind", "Min medvind vara längre än vid nollvind"],
        ["Min final och medvind vara ungefär lika långa", "Jag börjar mitt landningsvarv i höjd med min planerade landningspunkt", "Min landningshastighet vara högre"]),
    Question.qManyA("Om det blåser inget kommer", ["Min final och medvind vara ungefär lika långa", "Jag börjar mitt landningsvarv i höjd med min planerade landningspunkt", "Min landningshastighet vara högre"],
        ["Min final vara längre än min medvind", "Min final vara kortare än vid vind", "Min medvind vara längre än med vind"]),
    Question.oneQ("Om jag är osäker på om jag har höjd att flyga över träd mellan mig och fältet bör jag?",
        "Sick sacka och landa längre ifrån så jag inte landar i träden eller deras turbulens", ["Göra mig liten och flyga med fulla uppsläpp för att ta mig så långt som möjligt."]),
    Question.qManyA("Efter jag landat och ska gå mot hangaren bör jag", ["Titta upp efter andra hoppare", "Säkerställa att jag fått upp hela fallskärmen", "Titta var flygplanet är så man inte går framför det när det taxar."], []),
];

const landningQuizSection = <Section id="landning-quiz" name="Quiz">
    <SectionHeader>Quiz, landning</SectionHeader>
    <Questionary questions={landningQuiz} />
</Section>;
const Landning =
    ({ setSection, setArticle }) => (
        <Article name="Landning" icon={faPlaneArrival} id="landning" setArticle={setArticle} setSection={setSection}>
            {landningIntro}
            {landningRiktning}
            {LandningVarv}
            {landningFlar}
            {landningRullning}
            {landningUte}
            {landningBargning}
            {landningQuizSection}
        </Article>
    );

const landningIntro = <DocsHeader>
    <DocsHeading note="Updaterad: 2022-07-13">Landning</DocsHeading>
    <DocsIntro>
        <Image image={landning} imageSmall={landning_small} alt="Landning" />

        <p>Landningen har i likhet med frifallet prioriteter som ska följas i ordning. Dessa finns
            för att minska skaderisken i landning. Hårda landningar som leder till fot och
            ankelskador är de absolut vanligaste skadorna inom fallskärmshoppning.</p>
        <p>Innan man kommer till landningens prioriteter har man fortfarande skärmflygandets
            prioritet som är att ta sig till ett lämpligt landningsområde. Landningens prioriteter
            börjar på ca 80m. Innan dess är prioriteten att hitta ett område man kan landa på utan
            turbulens eller farliga hinder. Det kan vara hemma på fältet eller en åker långt bort.
        </p>
        <ol>
            <li value="0"><b>Lämpligt landningsområde</b>, var på ett bra sälle att landa. Ha marginal att missa den planerade landningspunkten i alla riktningar</li>
            <li><strong>Skärmen parallellt med marken</strong>, vi färdas rakt utan att svänga.
                Svänger man ökar sjunkhastigheten</li>
            <li><strong>Hinderfritt</strong>, fritt från hinder och faror </li>
            <li><strong>Landningsställning</strong>, benen ihop redo att göra fallskärmsrullning.
                Armarna fult uppsträckta under inflygningen och minst halv broms för nedslaget.</li>
            <li><b>Håll kvar bromsarna</b>, flyg fallskärmen till du står säkert på marken. Har man
                börjat bromsa får man bara bromsa mer, aldrig mindre innan man har landat</li>
            <li><b>Mot vinden</b>, flyger vi rakt mot vinden är vår framåtfart så låg som går.
                Avviker vi ska vi ha koll så vi inte flyger in framför andra hoppare som landar rakt
                mot vinden. Upp till 30 grader från vinden gör inte så stor skillnad på hastigheten
                om vi behöver undvika hinder. 1a prioriteten går före och vi får bara korrigera,
                inte svänga under 100 meter.</li>

        </ol>
        <p>Följer man dessa fem är risken att skada sig i landningen väldigt låg. Bryter man någon
            går skaderisken upp. Det finns scenarion man kan försätta sig där man skulle vilja bryta
            dessa. Har man siktat in sig på att landa rakt in i flygplanets propeller så är att
            svänga sig i baken åt och bryta lårbenet att föredra framför att förvandlas till
            köttfärs. Den mycket bättre lösningen är att på högre höjd välja en landningspunkt med
            mer marginal till landningsbana för att försäkra att om/när man missar sin plan är det
            fortfarande säkert att landa.</p>
        <p>Den sista faran att akta sig för när man är åter på marken och långt bort från var
            flygplan kör är andra hoppare. Beroende på vind och storlek på fallskärm kan hoppare
            flyga över marken i närmare 100 km/h. Man står still kollar upp bakom sig att det är
            fritt. Samlar ihop sin fallskärm och sen går tillbaka till packområdet med blicken i
            himlen för att spana efter fler hoppare.</p>
        <p>Närmast hangaren landar tandem. När man kommer dit är man extra varsam och ger dem stora
            marginaler för sina landningar när man går förbi. De är tunga och samtliga tandempiloter
            kommer kommer flyga in i dig framför att göra sista sekunden svängar och riskera landa
            hårt med sin passagerare.</p>
    </DocsIntro>
</DocsHeader>;

const landningRiktning = <Section id="landningsriktning" name="Landningsriktning">
    <SectionHeader>Landningsriktning</SectionHeader>
    <Image image={riktning} imageSmall={riktning_small} alt="Landningsriktning" />

    <p>Utifrån prioriteringarna ovan vill vi hitta vilken riktning som är mot vinden. Generellt
        landar vi alltid efter T-t. Är det tveksamt kommer dagens hoppledare lägga ut ett statiskt T
        på marken som bestämmer riktning. Motiveringen är att vi lite vind gör det inte speciellt
        stor skillnad om man landar sidvind men det uppstår fara om man landar mot varandra. </p>
    <p>Är vind T-t opålitligt och inget T utlagt bestämmer förste hoppare på ett landningsområde
        landningsriktningen.
    </p>
</Section>;

const LandningVarv = <Section id="landningsvarv" name="Landningsvarv">
    <SectionHeader>Landningsvarv</SectionHeader>
    <p>
        Bortsett från marken är det farligaste vid landning andra hoppare. Att flyga förutsägbart
        väldigt viktigt för att inte kollidera. Man vill från 100m flyga rakt mot vinden mot sin
        planerade landningspunkt. Det är sista sträckan i en landningsvarv. Till sin 100m-punkt
        flyger man 90 grader mot vinden från sin 200m punkt. Till sin 200m-punkt flyger man medvind
        från sin 300m punkt som är starten på landningsvarvet.
    </p>
    <p>Normalt är att vi flyger vänster varv. Det innebär att på varje höjd svänger man vänster. Se
        nedan för ingen vind. Den röda sträckan kallas final. Blå bas. Grön medvind.</p>
    <Image image={landningsvarv} imageSmall={landningsvarv_small} alt="Landningsvarv 0 vind" />

    <p>Höjderna kör man alltid samma men längden på benen varierar beroende på fallskärm och vind.
        Blåser det kommer man kortare mot vinden på final och längre med vinden på sin medvind.
        bas blir lite skråad.</p>
    <Image image={landningsvarv2} imageSmall={landningsvarv2_small} alt="Landningsvarv 6m/s vind" />

</Section>;

const landningFlar = <Section id="landningsflar" name="Landningsflär">
    <SectionHeader>Landningsflär</SectionHeader>
    <Image image={flar} imageSmall={flar_small} alt="Flär" />

    <p>Landningsflär är att använda full broms i sista sekund så man använder all fallskärmens
        lyftkraft för att stanna upp precis innan marken och landa mjukt. Inför flären flyger man
        med bromsarna hela vägen upp till metallringarna så fallskärmen flyger så rent som möjligt.
        Kallas fulla uppsläpp. 3 meter över marken tar man halv broms. Styrhandtagen till axelhöjd.
        1.5 meter tar man full broms. Det är styrhandtagen till skrevet. Man gör rätt i att föra
        styrhandtagen framför sig. Man är starkast. Man ser att man rör sig symmetriskt och axlar är
        inte i risk. Man backar aldrig i sin flär. Flärar man för tidigt håller man kvar och gör en
        rullning när man landar. En för hög flär kommer bli en hårdare landning men inte jättehård.
        Släpper man upp tar fallskärmen fart. Är man osymmetrisk i sin flär kommer fallskärmen att
        svänga. Det korrekta är att svänga emot och titta var man vill åka. Sträcker man ut en arm
        för att ta emot sig svänger man sannolikt mer åt det håller och kraschar.</p>
</Section>;

const landningRullning = <Section id="rullning" name="Fallskärmsrullning">
    <SectionHeader>Fallskärmsrullning</SectionHeader>
    <Image image={rullning} imageSmall={rullning_small} alt="Krasch" />

    <p>(Bilden är inte på en fallskärmsrullning. Den är på en som släppte upp i sista sekund.)</p>
    <p>Fallskärmsrullning är teknik för att absorbera kraften från en hård landning utan att skada
        sig. Den har sin bakgrund när folk hoppade rundkallotter och hård landing var mer regel än
        undantag. Med moderna vingfallskärmar landar man väldigt mjukt om man flärar vi rätt
        tillfälle. Missar man lite blir det hårdare. Naturen av det är att man sannolikt gör sina
        hårdare landningar i början av sin fallskärmskarriär. Det finns en bra beskrivning på
        wikipedia den här författaren inte tänker plagiera. Rent praktiskt övande av
        fallskärmsrullning görs på grundkursen. Utöver det har brittisk militär också en fin film.
    </p>
    <a href="https://en.wikipedia.org/wiki/Parachute_landing_fall" target="_blank"
        rel="noopener noreferrer">Fallskärmsrullning på engelska wikipedia</a>
    <br />
    <br />
    <a href="https://www.youtube.com/watch?v=Lu2f1u928xk" target="_blank"
        rel="noopener noreferrer">British army parachute landing fall</a>
</Section>;

const landningUte = <Section id="utelanding" name="Utelandning">
    <SectionHeader>Utelandning</SectionHeader>
    <Image image={utelandning} imageSmall={utelandning_small} alt="Åkerlandning" />
    <p>Utelandning är samlingsnamn på att inte landa på sitt planerade landningsområde. Bäst är
        såklart att titta ner innan man hoppar av och se till att vara på rätt ställe. Tyvärr är det
        inte alltid det räcker om vinden in är vad man tror vilket är den vanligaste anledningen att
        landa ute.</p>
    <p>Ju tidigare man inser att man kommer landa ute desto bättre. Det finns bra områden att landa
        på åt alla håll från flygfältet. Risken uppstår när man inser att man inte kommer komma dit
        man vill i sista sekund och ångrar sig. Klassiska skadeorsaker är svänga i sista sekund,
        landa i turbulensen bakom träd man trodde man skulle ta sig förbi eller rent av i träden.
        I den andan ska man komma ihåg att det många gånger kan vara bättre att landa längre bort än
        man tänkt ifall man har ett hinder mellan sig och fältet. Det kan också vara så att om man
        hänger ovanför något farligt kommer man inte ta sig till andra sidan av det mot vinden men
        flyger man medvind en bit kan man landa säkert bortanför det. I enlighet med våra
        prioriteringar för landningen är det också tydlige att det är bättre att landa ute på en
        åker än att landa full fart medvind på fältet hemma. Ännu värre om man precis kommer hem och
        försöker svänga runt i sista sekund. Desto tidigare man tar sitt beslut desto bättre.
    </p>
    <Image image={valAvPlats} imageSmall={valAvPlats_small} alt="Bra dåliga landningsområden" />

    <p>Bilden ovan visar att om man bara flyger blind hemåt så kan man hamna i att landa i den röda
        turbulenta zonen medan det finns flera hektar av bättre område innan dess. Hamnar man i den
        här situationen är det en bra idé att flyga lite sick sack på hög höjd så man är säker på
        att man inte landar i träden eller turbulensen. Det är väldigt få som skadar sig av att gå
        100m extra.</p>
    <p>Desto tidigare man inser att en utelandning kommer hända desto tidigare kan man välja ett bra
        ställe att landa på.</p>
    <p>Har man möjlighet är det fördelaktigt att landa i anslutning till en väg så man kan bli
        hämtad. För att kunna bli hämtad är det bra att ha med sig en mobiltelefon där man kan
        meddela både var man är men framför allt att man är okej.
    </p>

    <h3>Dåliga platser för utelandningar och vad att tänka på</h3>
    <strong>Taklandning</strong>
    <Image image={taklandning} imageSmall={taklandning_small} alt="Taklandning" />

    <p>Undvik att landa på tak. Landar man på ett tak flärar man som vanligt. När man landat kopplar
        man loss RSLen. Har man tid att göra det tidigare är det uppmuntrat. Det gör
        man ifall huvudskärmen tar vind och börjar dra så man riskerar att trilla ner så kan man
        kutta utan att reserven kommer ut. När man väl still på taket tar man det lugnt och
        undviker att skada sig genom att trilla ner. Väntar till något hittar en stege eller så.</p>

    <strong>Vattenlandning</strong>
    <Image image={vattenlandning} imageSmall={vattenlandning_small} alt="Vattenlandningsövning" />

    <p>(Bilden är på ett övningstillfälle)</p>
    <p>Det är allmänt dåligt att landa i vatten och det bör undvikas. Finns det möjlighet att åka
        med vinden till andra sidan vattnet och landa på land är det såklart att föredra. Ser man
        att man oundvikligt kommer landa i vatten lossar man på remmarna i selen. Bröstremmen tar
        man loss och benremmarna lättar man försiktigt utan ge skärmen snett input. Remmarna blir
        stelare i vatten och är svåra att ta loss i vattnet. Man kan lossa RSLen. Man landar normalt
        med fötterna framför beredd på att vattnet är grunt och det finns hårda saker nedanför. Tar
        ett djupt andetag innan man nuddar vattnet. Är vattnet djupt kommer man sjunka ner under
        ytan med fallskärmen ovanför sig. Där tar man sig ur selen och simmar neråt framåt och sen
        upp till ytan för att undvika att trassla in sig i linor. Om du inte är väldigt nära land
        håll dig i närheten av fallskärmen. Den är stor, syns och riggen flyter en stund med
        reserven i.</p>
    <p>Har du en flytväst blås upp den innan du landar.</p>
    <p>Det kan verka frestande att försöka koppla loss fallskärmen innan man landar i vattnet men
        det höjer markant skaderisken vid nedslaget. Framför allt om det skulle vara grunt.</p>
    <strong>Trädlandning</strong>
    <Image image={trad} imageSmall={trad_small} alt="Träd" />

    <p>Undvik att landa i träd. Bilden har ingen hoppare i sig men det har hängt hoppare i denna rad
        av träd. Träden på bilden är en ett träd bred rad med stora åkrar på båda sidor om sig. Vi
        vet med oss att det är bättre att landa bortom och gå längre efter att ha landat på andra
        sidan än att bli nästa som hänger i dem.</p>
    <p>Landar man i träd håller man benen tätt ihop och är redo att göra fallskärmsrullning. Halv
        flär med armarna framför bröst och ansikte för att skydda mot kvistar. Faller du igenom
        rulla i nedslaget. Blir du hängande häng kvar. Man skadar sig inte från att hänga kvar i ett
        träd fem
        meter upp. Man skadar sig om man faller fem meter efter att ha kuttat utan en plan.</p>

    <strong>Åkerlandning</strong>
    <Image image={akerlandning} imageSmall={akerlandning_small} alt="Åkerlandning" />

    <p>Åkerlandning eller andra stora platta ytor är att föredra om man landar ute. Spana på några
        stycken. En nyplöjd åker är mycket knöligare än en nysådd.</p>

    <strong>Landningsbanan</strong>
    <Image image={banan} imageSmall={banan_small} alt="Landningsbana" />

    <p>(Hopparen på bilden hann undan.)</p>
    <p>Landningsbanan är en av de farligaste platserna att landa och oturligt nog precis bredvid
        våra landningsområdena. Den stora risken är såklart flygplan som har svårt att väja, inte
        kan stanna plötsligt, har svårt att se framåt och när de väl bromsat in lite inte möjlighet
        att lyfta plötsligt igen. Det gör att framför flygplan som landar är en extremt farlig plats
        att vara på. De färdas mycket snabbare än bilar och har en propeller som med lätthet hackar
        en i småbitar fram.</p>
    <p>Det finns ingen anledning att landa på landningsbanan</p>
    <ul>
        <li>Landa på banan eller långt bort på andra sidan? <strong>Landa på andra sidan.</strong>
        </li>
        <li>Landa på banan eller ute? <strong>Landa ute. En åker är mycket bättre
            landningsplats.</strong></li>
        <li>Landa på banan eller sidvind? <strong>Landa sidvind.</strong> Är du på väg mot banan på
            din final korrigera så du landar sidvind säkert.</li>
    </ul>
    <p>Har man landat på en landningsbana och inte är 101% säker på att det inte finns något
        flygplan i närheten så bärgar man inte eller samlar ihop fallskärmen. Man springer av och
        släpar sin utrustning bakom sig. Väl av samlar man ihop den.</p>

    <strong>Kraftledning</strong>

    <Image image={kraftledning} imageSmall={kraftledning_small} alt="Kraftledning" />

    <p>Kraftledning bland de sämsta tänkbara ställen att landa på. Att svänga på låg höjd och få ett
        brutet lårben kan vara att föredra. Blir man hängande i en kraftledning vägra hjälp tills
        det är helt säkert att ledning är avstängd och du och din räddare inte blir elektrifierade
        när ni nuddar varandra. Försök inte nudda eller klättra på något runt dig.
    </p>

    <strong>Vägar</strong>
    <br />
    <Image image={vag} imageSmall={vag_small} alt="Vägar" />

    <p>Landa inte på vägar men gör du det var beredd på hårt underlag. Ta dig av vägen snabbt så du
        inte blir påkörd. Har man valmöjligheten att göra det säkert kan det underlätta hämtning att
        landa i närheten av en väg eller åtminstone komma ihåg var det finns vägar så man vet var
        att gå.
    </p>

    <strong>Hagar</strong>
    <br />
    <Image image={hage} imageSmall={hage_small} alt="Vägar" />

    <p>Hagar kan vara platta ytor men bör undvikas att landa på. Risken är att man skrämmer djur att
        antingen springa på en själv eller fly genom staket.</p>


</Section>;

const landningBargning = <Section id="bargning" name="Bärgning utav fallskärm">
    <SectionHeader>Bärgning utav fallskärm</SectionHeader>
    <Image image={bargning} imageSmall={bargning_small} alt="Bärgad" />

    <p>Efter man landat och är stabil på marken springer man runt fallskärmen så man är nedvind av
        den. På så vis kan den inte ta luft och dra omkull en. Därefter sätter man bromsarna. Gör
        stora slag med linorna i en hand till man puttat slidern upp till fallskärmen. Ta tag såg
        högt upp på linorna du kan. Ta varningslappen på fallskärmen och bagen och nyp fast i samma
        hand. Plocka upp piloten. Lyft och kolla så inget hänger ner och släpar.</p>
    <p>Innan du börjar gå mot hangaren titta upp och se att du inte går framför någon som landar.
    </p>
</Section>;


export { Landning, landningQuiz, landningIntro, landningRiktning, LandningVarv, landningFlar, landningRullning, landningUte, landningBargning, landningQuizSection };